import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { message } from "antd";
import { useAuth } from "../../../utility/AuthContext";
import { useNavigate } from "react-router-dom";

import { Field, Form, Formik } from "formik";
import {
  updateToken,
  updateUserInfo,
} from "../../../features/user/userSlice";
import { useAppDispatch } from "../../../store/hooks";

import { loginViaId } from "../../../server/Auth";
import { GoogleSignInBtn } from "../../../../assets/GoogleSignInBtn";

import {
  setAccessTokenSession,
  setRefreshTokenSession,
} from "../../../utility/common/session-store";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LoginComponent = () => {
  const { t } = useTranslation();
  const { setShowLoginModal, login } = useAuth();
  const [showPassword, setShowPassword] = useState(false);

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const loginSuccess = () => {
    messageApi.success({
      content: t("Log In Success!"),
    });
  };

  const loginError = () => {
    messageApi.error({
      content: t("Log In Failed!"),
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleGoogleLogin = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}auth/oauth/google/login`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
      const resJson = await response.json();

      if (resJson.code === 0 && resJson.url) {
        window.location.href = resJson.url;
      } else {
        console.error("Invalid response from backend:", resJson);
        loginError();
      }
    } catch (error) {
      console.error("Failed to initiate Google login:", error);
      loginError();
    }
  };

  return (
    <>
      {contextHolder}
      <div className="form">
        <Formik
          validateOnMount={true}
          enableReinitialize={true}
          initialValues={{}}
          onSubmit={(values: any) => {
            loginViaId(values.email, values.password)
              .then((res) => {
                const data = res.data.data;
                setAccessTokenSession(data.token);
                setRefreshTokenSession(data.refresh_token);
                dispatch(updateUserInfo(data.user));
                dispatch(
                  updateToken({
                    access_token: data.token,
                  })
                );
                login(data.token, data.refresh_token);
                loginSuccess();
                if (data.user.is_provider === true) {
                  navigate("/installation");
                }
                setShowLoginModal(false);
              })
              .catch((error) => {
                console.log(error);
                loginError();
              });
          }}
        >
          <Form>
            <div className="label-wrapper">
              <label htmlFor="email">{t("E-Mail")}</label>
              <Field name="email" type="email" />
            </div>
            <div className="label-wrapper">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <label htmlFor="password">{t("Password")}</label>
                <small
                  className="forgot-password-text"
                  onClick={() => navigate("/reset-password")}
                >
                  {t("Forgot Password")}?
                </small>
              </div>
              <div style={{ position: "relative" }}>
                <Field
                  name="password"
                  type={showPassword ? "text" : "password"}
                />
                <span
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                >
                  {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                </span>
              </div>
            </div>
            <button className="sign-in-btn" type="submit">
              {t("Log In")}
            </button>
          </Form>
        </Formik>
        <div className="login-modal-bottom">
          <p><GoogleSignInBtn fn={handleGoogleLogin} /></p>
        </div>
      </div>
    </>
  );
};

export default LoginComponent;